import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const moving = type => {
  return (
    <div className="container">
      {breadcrumbs(type, [{ href: "/voice2", text: "お客様の声" }, { href: "/voice2/moving", text: "引越し・リフォームの際の一時収納に" }])}
      
      <div className="moving">
        <h1 id="useCaseContentsHead"><span>引越し・リフォームの際の一時収納に</span></h1>
        <div className="useCaseImg"><img src="resource/img/static/voice2/moving/kv_01.jpg" alt="活用事例"/></div>
          <div id="useCaseVoiceArea">
            <div className="useCaseBox">
              <h2>荷物整理で家が広々とした</h2>
              <div className="useCaseBoxInfo">
                <p className="useCaseName">転勤の関係で引越ししたM様</p>
                <p className="useCaseText">
                  転勤で、栃木県から三重県へ赴任する際、妻と子供達は東京の実家に、親と同居する事としました。栃木県の家は、広く大きかったのですが、東京の家は狭い為、トランクルームを借りる事にしました。荷物が減ったことで、狭い東京の家で、妻と子供達が生活していけるスペースが確保できて、のびのびと生活がすることができる様になったことで私も安心しました。
                </p>
              </div>
            </div>
          
          <div className="useCaseBox">
            <h2>家の建て替えが終わるまでの収納に</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">家の建て替えをしたH様</p>
              <p className="useCaseText">
                住んでいた家が、老朽化の影響もあり建て替えを進めたときにトランクルームを、利用させて頂きました。建て替えている間に住んでいたアパートは狭く、とても今までのように荷物を置ける環境ではなかったため、こういったスペースの存在は大変助かります。新しく建て替えた家には、すぐ必要なものとそうでないものとを分けて、そうでないものはトランクルームに閉まっておいて、建て替え前より極力、荷物を減らして生活しております。
              </p>
            </div>
          </div>
          
          <div className="useCaseBox">
            <h2>二世帯での荷物整理に！</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">二世帯で住んでいるM様</p>
              <p className="useCaseText">
                転居先に入りきらない家具や家電を一時収納する為に利用し始めました。転居後、二世帯になった為に家具や家電がダブってしまい収納場所が必要となりました。ハローストレージさんにお世話になり、そのおかげで必要性のない家具や家電の分別が出来てスッキリしました。トランクルームがあると思うと、何かと無駄な買い物も増えてきた気がしますが、その分、生活スペースに余裕が出てきたように思えます。去年、広いタイプの部屋に移動して、今はわたしの実家と共同で使っています。二世帯で使っているから、使用料は割安ですので、こんな使い方もお勧めです！
              </p>
            </div>
          </div>
          
          <div className="useCaseBox">
            <h2>家を借りるよりも安い！</h2>
            <div className="useCaseBoxInfo">
              <p className="useCaseName">長期海外出張のN様</p>
              <p className="useCaseText">
                仕事の関係で、長期海外出張を言い渡されたて真っ先に思ったことは、「家の荷物どうしよう？」でした。海外に家電などを持っていくわけにもいかないため、実家に相談したところ、「こっちもスペースがないよ」とNGの連絡．．．<br/>
                どうしようかと悩んでいたときに、ハローストレージさんのトランクルームをネットで見つけました。何年後に日本に帰ってくるかもわからなかったため、家を借りておくよりも安く済むと思い、利用を始めました。セキュリティもしっかりしているため、安心して収納しておけます。
              </p>
            </div>
          </div>
        </div>

        <div id="pageTopAreaBottom">&nbsp;</div>

        <div id="useCaseContentsLink">
          <h2>その他の活用事例</h2>
          <ul>
            <li><a href="/voice2/moving/"><img src="resource/img/static/voice2/moving/use_case_01.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/moving/"><span>引越し・リフォームの際の一時収納に</span></a></div></li>
            <li><a href="/voice2/season/"><img src="resource/img/static/voice2/moving/use_case_02.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/season/"><span>季節外用品・育児用品の収納に</span></a></div></li>
            <li><a href="/voice2/hobby/"><img src="resource/img/static/voice2/moving/use_case_03.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/hobby/"><span>趣味・コレクションの収納に</span></a></div></li>
            <li><a href="/voice2/organization/"><img src="resource/img/static/voice2/moving/use_case_04.jpg" alt=""/><span>詳細はこちら</span></a><div className="useCaseContentsLinkBtn"><a href="/voice2/organization/"><span>法人・団体の荷物収納に</span></a></div></li>
          </ul>
        </div>
        <p className="useCaseTextLink"><a href="/voice2/">⇒ お客様の声をみる</a></p>

        <div id="useCasePrefecturalLink">
          <a href="/">
            <div id="useCasePrefecturalLinkTitle"><img src="resource/img/static/voice2/moving/use_case_cv_area_copy.png" alt=""/></div>
            <div id="useCasePrefecturalLinkButton">近くのトランクルームを探す</div>
          </a>
        </div>
      </div>
    </div >
  );
};



// WEBPACK FOOTER //
// ./pages/new/moving.jsx